import {v4 as uuidv4} from 'uuid';

export class Guid {
  static newGuid(): string {
    return uuidv4();
  }
}
